import React, { useContext, useState, useRef, useEffect } from "react";
import { AudioContext } from "../../services/AudioContext";
import { RadioContext } from "../../services/RadioProvider";
import useSyncedTrack from "../../services/useSyncedTrack";
import "./RadioPlayerCoverFrame.css";

export default function RadioPlayerCoverFrame() {
  const { nowPlaying } = useContext(RadioContext);
  const audioContext = useContext(AudioContext);
  const coverRef = useRef(null);

  const [initialTrack, setInitialTrack] = useState(null);

  const audioTimeMs = audioContext?.audioTimeMs ?? 0;
  const playbackState = audioContext?.playbackState;
  const syncedTrack = useSyncedTrack(nowPlaying, audioTimeMs, playbackState);

  const coverEffects = ["d-fade", "d-slide", "d-zoom"];
  const getRandomEffect = () => coverEffects[Math.floor(Math.random() * coverEffects.length)];

  useEffect(() => {
    const firstTrack = nowPlaying?.history?.[0];
    if (firstTrack) {
      setInitialTrack(firstTrack);
    }
  }, [nowPlaying]);

  const currentTrack = syncedTrack || initialTrack

  useEffect(() => {
    if (coverRef.current && currentTrack?.coverUrl) {
      coverRef.current.className = "d-cover " + getRandomEffect();
    }
  }, [currentTrack?.coverUrl]);

  const artist = currentTrack?.artist || "";
  const songTitle = currentTrack?.title || "";
  const coverUrl = currentTrack?.coverUrl || "";
  const modifiedCoverUrl = coverUrl;

  return (
    <div className="d-outer-frame">
      <div className="d-cover-frame">
        <div id="d-frame" style={{ backgroundImage: `url(${coverUrl})` }} ></div>
        {coverUrl && <img ref={coverRef} className="d-cover d-fade" src={modifiedCoverUrl} alt="Cover" />}
        <div className="d-title">
          <div className="d-title-info">
            LIVE PLAYING TRACK
          </div>
          <div className="underline"></div>
          <div className="d-title-artist">
            {artist}
          </div>
          <div className="d-title-title">
            {songTitle}
          </div>
          <div className="underline"></div>
        </div>
      </div>
    </div>

  );
}
